import React, { Component, Fragment } from 'react';
import Sidebar from './Sidebar.js';
import Topbar from './Topbar.js';
import Content from './Content.js';
import ApplicationContainer from './ApplicationContainer.js';
import { WebServiceContextConsumer } from './Providers/WebServiceProvider.js';

import logo from './assets/images/tovertaal_logo.png';

class App extends Component
{
	renderContent (context) {
		return (  
			<Fragment>
				<Topbar/>
				<section className="columns is-gapless" style={{height: context.auth.getUser() ? 'calc(100% - 71px)' : '100%', marginTop: 0}}>
					{ 
							context.auth.getUser() 
							? (
								<div className="column sidebar-container is-2-tablet is-1-desktop is-12-mobile">
									<Sidebar/>
								</div>
							)
							: ("")
					}

					{ 
						!context.auth.getUser() 
							? (
								<div className="column is-12" style={{overflow: 'unset', position: 'relative'}}>
									<Content/>
								</div>
							)
							: (
								<div className="column main-content" style={{overflow: 'unset', position: 'relative'}}>
									<Content/>
								</div>
							)
					}
				</section>
			</Fragment>
		);
	}

	renderLoading () {
		return (
			<section className="hero is-fullheight" style={{backgroundColor: '#aed8d6', color: 'white', zIndex: 9999}}>
			  <div className="hero-body">
			    <div className="container">
			    	<div className="columns is-gapless">
			    		<div className="column"></div>
			    		<div className="column has-text-centered">
					      <h1 className="title">
					        <img src={logo} alt="Tovertaal: Localisation System" width="140" height="55" />
					      </h1>
					      <h2 className="subtitle">
					        Loading Tovertaal...
					      </h2>
			    		</div>
			    		<div className="column"></div>
			    	</div>
			    </div>
			  </div>
			</section>
		);
	}

	render() {
		return (
			<ApplicationContainer>
				<WebServiceContextConsumer>
				 	{ 
				 		context => (context.bootstrapped) ? (this.renderContent(context)) : (this.renderLoading())
					}
				</WebServiceContextConsumer>
			</ApplicationContainer>
		);
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js